module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-hb.76956592.png";